module.exports = __webpack_public_path__ + "static/media/delete.f84c5556.svg";